import ContentLayout from '@/layouts/content-layout'
import TrendsView from '@/sections/trends/view/trends-view'

export default function TrendsPage() {
  return (
    <ContentLayout title="เทรนด์">
      <TrendsView />
    </ContentLayout>
  )
}
